(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  // Lets shoppers manually switch the Current Edit shelf between curated,
  // best-selling, and newest storefront views while preserving native swipe.
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function text(node) {
      return node ? node.textContent.trim() : '';
    }

    document.querySelectorAll('[data-x-featured]').forEach(function (section) {
      var row = section.querySelector('[data-x-featured-row]');
      if (!row) return;

      var limit = parseInt(section.getAttribute('data-products-count') || '8', 10);
      var kicker = section.querySelector('[data-x-featured-kicker]');
      var titleMain = section.querySelector('[data-x-featured-title-main]');
      var titleItalic = section.querySelector('[data-x-featured-title-italic]');
      var lede = section.querySelector('[data-x-featured-lede]');
      var link = section.querySelector('[data-x-featured-link]');
      var modesEl = section.querySelector('[data-x-featured-modes]');
      var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-x-featured-mode]'));
      var edgePrev = section.querySelector('[data-x-featured-edge-prev]');
      var edgeNext = section.querySelector('[data-x-featured-edge-next]');
      var loadId = 0;
      var touchStart = null;
      var blockClickUntil = 0;
      var edgeFrame = null;
      var edgeVelocity = 0;
      var edgeLastTime = 0;
      var edgeSyncFrame = null;
      var edgeMedia = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 961px)') : null;
      var modes = [
        {
          key: 'current',
          html: row.innerHTML,
          loaded: true,
          kicker: text(kicker),
          titleMain: text(titleMain),
          titleItalic: text(titleItalic),
          lede: text(lede),
          linkText: link ? text(link) : 'Shop all fragrance →',
          linkHref: link ? link.getAttribute('href') : '/collections/all'
        },
        {
          key: 'best',
          url: section.getAttribute('data-best-url') || '/collections/all?sort_by=best-selling',
          kicker: 'Best sellers',
          titleMain: 'Best',
          titleItalic: 'sellers.',
          lede: 'The bottles shoppers keep coming back for right now.',
          linkText: 'Shop best sellers →',
          linkHref: section.getAttribute('data-best-url') || '/collections/all?sort_by=best-selling'
        },
        {
          key: 'newest',
          url: section.getAttribute('data-newest-url') || '/collections/all?sort_by=created-descending',
          kicker: 'Newest additions',
          titleMain: 'Newest',
          titleItalic: 'additions.',
          lede: 'Fresh arrivals just added to the shelf.',
          linkText: 'Shop new arrivals →',
          linkHref: section.getAttribute('data-newest-url') || '/collections/all?sort_by=created-descending'
        }
      ];

      function modeByKey(key) {
        return modes.find(function (mode) { return mode.key === key; }) || modes[0];
      }

      function setHeading(mode) {
        if (kicker) kicker.textContent = mode.kicker;
        if (titleMain) titleMain.textContent = mode.titleMain;
        if (titleItalic) titleItalic.textContent = mode.titleItalic;
        if (lede) lede.textContent = mode.lede;
        if (link) {
          link.textContent = mode.linkText;
          link.setAttribute('href', mode.linkHref);
        }
      }

      function setActiveButton(key) {
        if (modesEl) modesEl.setAttribute('data-active', key);
        buttons.forEach(function (button) {
          var active = button.getAttribute('data-x-featured-mode') === key;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      function cardIdentity(card) {
        return card.getAttribute('data-product-id') ||
          card.getAttribute('data-product-handle') ||
          card.querySelector('.product-card__view')?.getAttribute('href') ||
          card.textContent.trim();
      }

      function seenCardsFrom(scope) {
        var seen = {};
        Array.prototype.slice.call(scope.querySelectorAll('.product-card')).forEach(function (card) {
          var id = cardIdentity(card);
          if (id) seen[id] = true;
        });
        return seen;
      }

      function htmlFromCollection(markup, maxCards, seenSeed) {
        var doc = new DOMParser().parseFromString(markup, 'text/html');
        var cards = Array.prototype.slice.call(doc.querySelectorAll('.product-card'));
        var seen = seenSeed || {};
        return cards.filter(function (card) {
          var id = cardIdentity(card);
          if (!id || seen[id]) return false;
          seen[id] = true;
          return true;
        }).slice(0, maxCards || limit).map(function (card) {
          card.querySelectorAll('script').forEach(function (script) { script.remove(); });
          return '<div class="x-featured__card">' + card.outerHTML + '</div>';
        }).join('');
      }

      function ensureCurrentShelf() {
        var currentCount = row.querySelectorAll('.x-featured__card').length;
        if (currentCount >= limit) {
          modes[0].html = row.innerHTML;
          return Promise.resolve();
        }

        return fetch('/collections/all?sort_by=manual', {
          credentials: 'same-origin',
          headers: { Accept: 'text/html', 'Cache-Control': 'no-cache' }
        })
          .then(function (response) { return response.ok ? response.text() : ''; })
          .then(function (markup) {
            if (!markup) return;
            var needed = Math.max(0, limit - row.querySelectorAll('.x-featured__card').length);
            if (!needed) return;
            var html = htmlFromCollection(markup, needed, seenCardsFrom(row));
            if (!html) return;
            row.insertAdjacentHTML('beforeend', html);
            modes[0].html = row.innerHTML;
          })
          .catch(function () {});
      }

      function loadMode(mode) {
        if (mode.loaded) return Promise.resolve(mode.html);
        return fetch(mode.url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
          .then(function (response) { return response.ok ? response.text() : ''; })
          .then(function (markup) {
            var html = markup ? htmlFromCollection(markup, limit) : '';
            if (!html) html = modes[0].html;
            mode.html = html;
            mode.loaded = true;
            return html;
          })
          .catch(function () { return modes[0].html; });
      }

      function formatMoney(cents) {
        var amount = (parseInt(cents || 0, 10) / 100).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return '$' + amount;
      }

      function variantPrice(variant) {
        return parseInt(variant && variant.price ? variant.price : 0, 10) || 0;
      }

      function isSampleVariant(variant) {
        var title = String((variant && (variant.public_title || variant.title || variant.name)) || '').toLowerCase();
        var compact = title.replace(/\s+/g, '').replace(/-/g, '');
        return title.indexOf('sample') !== -1 ||
          title.indexOf('discovery') !== -1 ||
          title.indexOf('vial') !== -1 ||
          title.indexOf('decant') !== -1 ||
          title.indexOf('travel') !== -1 ||
          title.indexOf('tester') !== -1 ||
          title.indexOf('mini') !== -1 ||
          compact.indexOf('0.7ml') !== -1 ||
          compact.indexOf('1ml') !== -1 ||
          compact.indexOf('1.5ml') !== -1 ||
          compact.indexOf('2ml') !== -1 ||
          compact.indexOf('3ml') !== -1 ||
          compact.indexOf('5ml') !== -1 ||
          compact.indexOf('10ml') !== -1 ||
          compact.indexOf('15ml') !== -1;
      }

      function lowestVariant(variants) {
        return (variants || []).reduce(function (best, variant) {
          if (!best) return variant;
          return variantPrice(variant) < variantPrice(best) ? variant : best;
        }, null);
      }

      function entryVariantFromProduct(product) {
        if (!product || !Array.isArray(product.variants) || !product.variants.length) return null;
        var availableBottles = product.variants.filter(function (variant) {
          return variant.available && !isSampleVariant(variant);
        });
        if (availableBottles.length) return lowestVariant(availableBottles);
        var bottles = product.variants.filter(function (variant) { return !isSampleVariant(variant); });
        if (bottles.length) return lowestVariant(bottles);
        var available = product.variants.filter(function (variant) { return variant.available; });
        return lowestVariant(available.length ? available : product.variants);
      }

      function applyEntryVariantToCard(card, variant) {
        if (!card || !variant || !variant.price) return;
        var price = parseInt(variant.price, 10);
        card.setAttribute('data-x-price', String(price / 100));
        card.setAttribute('data-variant-id', variant.id);
        card.setAttribute('data-product-variant-id', variant.id);
        card.setAttribute('data-x-price-source', 'bottle');
        card.setAttribute('data-x-display-variant-title', variant.title || variant.public_title || '');

        var priceRow = card.querySelector('.price-row');
        if (priceRow) {
          var from = priceRow.querySelector('.from');
          if (from) from.remove();
          var priceEl = priceRow.querySelector('.price') || priceRow.appendChild(document.createElement('span'));
          priceEl.className = 'price';
          priceEl.textContent = formatMoney(price);
        }

        card.querySelectorAll('[data-variant-id], [data-product-variant-id]').forEach(function (node) {
          node.setAttribute('data-variant-id', variant.id);
          node.setAttribute('data-product-variant-id', variant.id);
        });
        card.querySelectorAll('input[name="id"]').forEach(function (input) {
          input.value = variant.id;
        });
        card.querySelectorAll('[data-product-price]').forEach(function (node) {
          node.setAttribute('data-product-price', formatMoney(price));
        });
      }

      function hydrateEntryPrices(scope) {
        Array.prototype.slice.call(scope.querySelectorAll('.product-card')).slice(0, limit).forEach(function (card) {
          if (card.getAttribute('data-x-price-source') === 'bottle') return;
          var viewLink = card.querySelector('.product-card__view');
          var productUrl = card.getAttribute('data-product-url') || (viewLink ? viewLink.getAttribute('href') : '') || '';
          if (!productUrl) return;
          var jsonUrl = productUrl.split('?')[0].replace(/\/$/, '') + '.js';
          fetch(jsonUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(function (response) { return response.ok ? response.json() : null; })
            .then(function (product) {
              var variant = entryVariantFromProduct(product);
              if (variant) applyEntryVariantToCard(card, variant);
            })
            .catch(function () {});
        });
      }

      function delay(ms) {
        return new Promise(function (resolve) { window.setTimeout(resolve, ms); });
      }

      function maxScroll() {
        return Math.max(0, row.scrollWidth - row.clientWidth);
      }

      function featuredCardStep() {
        var card = row.querySelector('.x-featured__card');
        var styles = window.getComputedStyle ? window.getComputedStyle(row) : null;
        var gap = styles ? parseFloat(styles.columnGap || styles.gap || '0') : 0;
        return card ? card.getBoundingClientRect().width + (gap || 0) : Math.max(280, row.clientWidth * 0.55);
      }

      function syncEdgeAffordance() {
        edgeSyncFrame = null;
        if (!edgePrev || !edgeNext) return;

        var max = maxScroll();
        var canScroll = window.innerWidth >= 961 && max > 4;
        var left = row.scrollLeft;
        var canGoLeft = canScroll && left > 4;
        var canGoRight = canScroll && left < max - 4;
        var anchor = row.querySelector('.bottle-wrap') || row;
        var anchorRect = anchor.getBoundingClientRect();
        var sectionRect = section.getBoundingClientRect();

        if (anchorRect.height && sectionRect.height) {
          section.style.setProperty('--x-featured-row-center', (anchorRect.top - sectionRect.top + (anchorRect.height / 2)) + 'px');
        }

        edgePrev.hidden = !canGoLeft;
        edgeNext.hidden = !canGoRight;
        edgePrev.disabled = !canGoLeft;
        edgeNext.disabled = !canGoRight;
        section.classList.toggle('has-scroll-left', canGoLeft);
        section.classList.toggle('has-scroll-right', canGoRight);
      }

      function queueEdgeAffordanceSync() {
        if (edgeSyncFrame) return;
        edgeSyncFrame = window.requestAnimationFrame(syncEdgeAffordance);
      }

      function scrollFeaturedShelf(direction) {
        stopEdgeScroll();
        row.scrollBy({
          left: direction * Math.max(featuredCardStep() * 2, row.clientWidth * 0.7),
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
        window.setTimeout(queueEdgeAffordanceSync, 120);
        window.setTimeout(queueEdgeAffordanceSync, 520);
      }

      function resetShelfPosition() {
        stopEdgeScroll();
        row.scrollLeft = 0;
        row.scrollTo({ left: 0, behavior: 'auto' });
        queueEdgeAffordanceSync();
      }

      function canHoverScroll(event) {
        if (reduceMotion) return false;
        if (event && event.pointerType && event.pointerType !== 'mouse') return false;
        return window.innerWidth >= 961;
      }

      function stopEdgeScroll() {
        edgeVelocity = 0;
        edgeLastTime = 0;
        row.style.scrollSnapType = '';
        row.style.scrollBehavior = '';
        row.classList.remove('is-edge-scrolling', 'is-edge-scroll-left', 'is-edge-scroll-right');
        section.classList.remove('is-edge-scroll-left', 'is-edge-scroll-right');
        if (edgeFrame) {
          window.cancelAnimationFrame(edgeFrame);
          edgeFrame = null;
        }
        queueEdgeAffordanceSync();
      }

      function runEdgeScroll(now) {
        edgeFrame = null;
        if (!edgeVelocity || !canHoverScroll()) {
          stopEdgeScroll();
          return;
        }

        var max = maxScroll();
        if (max <= 4) {
          stopEdgeScroll();
          return;
        }

        var delta = edgeLastTime ? Math.min(2.2, Math.max(0.5, (now - edgeLastTime) / 16.67)) : 1;
        edgeLastTime = now || 0;
        var next = Math.max(0, Math.min(max, row.scrollLeft + (edgeVelocity * delta)));
        if (Math.abs(next - row.scrollLeft) > 0.1) row.scrollLeft = next;

        if ((next <= 0 && edgeVelocity < 0) || (next >= max && edgeVelocity > 0)) {
          edgeVelocity = 0;
          stopEdgeScroll();
          return;
        }

        queueEdgeAffordanceSync();
        if (edgeVelocity) edgeFrame = window.requestAnimationFrame(runEdgeScroll);
      }

      function updateEdgeScroll(event) {
        if (!canHoverScroll(event)) {
          stopEdgeScroll();
          return;
        }

        var rect = row.getBoundingClientRect();
        if (!rect.width || event.clientY < rect.top - 120 || event.clientY > rect.bottom + 90) {
          stopEdgeScroll();
          return;
        }

        var zone = Math.min(320, Math.max(150, rect.width * 0.24));
        var leftRatio = Math.min(1, Math.max(0, zone - (event.clientX - rect.left)) / zone);
        var rightRatio = Math.min(1, Math.max(0, zone - (rect.right - event.clientX)) / zone);
        var maxSpeed = Math.min(46, Math.max(30, row.clientWidth * 0.022));
        var velocity = 0;

        if (leftRatio > 0) velocity = -Math.pow(leftRatio, 1.12) * maxSpeed;
        if (rightRatio > 0) velocity = Math.pow(rightRatio, 1.12) * maxSpeed;

        edgeVelocity = velocity;
        if (velocity !== 0) {
          row.style.scrollSnapType = 'none';
          row.style.scrollBehavior = 'auto';
        }
        row.classList.toggle('is-edge-scrolling', velocity !== 0);
        row.classList.toggle('is-edge-scroll-left', velocity < 0);
        row.classList.toggle('is-edge-scroll-right', velocity > 0);
        section.classList.toggle('is-edge-scroll-left', velocity < 0);
        section.classList.toggle('is-edge-scroll-right', velocity > 0);

        if (edgeVelocity && !edgeFrame) edgeFrame = window.requestAnimationFrame(runEdgeScroll);
        if (!edgeVelocity) stopEdgeScroll();
      }

      function initEdgeArrows() {
        if (!edgePrev || !edgeNext || section.dataset.xFeaturedEdgeArrowsInit === '1') return;
        section.dataset.xFeaturedEdgeArrowsInit = '1';
        edgePrev.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          scrollFeaturedShelf(-1);
        });
        edgeNext.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          scrollFeaturedShelf(1);
        });
        row.addEventListener('scroll', queueEdgeAffordanceSync, { passive: true });
        window.addEventListener('resize', queueEdgeAffordanceSync, { passive: true });
        if (window.ResizeObserver) {
          new ResizeObserver(queueEdgeAffordanceSync).observe(row);
        }
        queueEdgeAffordanceSync();
      }

      function initHoverEdgeScroll() {
        if (section.dataset.xFeaturedHoverScrollInit === '1') return;
        section.dataset.xFeaturedHoverScrollInit = '1';
        if (!row.hasAttribute('tabindex')) row.setAttribute('tabindex', '0');

        section.addEventListener('pointermove', updateEdgeScroll, { passive: true });
        section.addEventListener('pointerleave', stopEdgeScroll, { passive: true });
        row.addEventListener('wheel', stopEdgeScroll, { passive: true });
        row.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          row.scrollBy({
            left: (event.key === 'ArrowRight' ? 1 : -1) * Math.max(280, row.clientWidth * 0.55),
            behavior: reduceMotion ? 'auto' : 'smooth'
          });
        });
        window.addEventListener('blur', stopEdgeScroll, { passive: true });
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) stopEdgeScroll();
        });
        if (edgeMedia && edgeMedia.addEventListener) {
          edgeMedia.addEventListener('change', stopEdgeScroll);
        } else if (edgeMedia && edgeMedia.addListener) {
          edgeMedia.addListener(stopEdgeScroll);
        }
      }

      function setMode(key) {
        var mode = modeByKey(key);
        var thisLoad = ++loadId;
        setHeading(mode);
        setActiveButton(mode.key);
        row.classList.add('is-refreshing');
        stopEdgeScroll();
        Promise.all([loadMode(mode), delay(reduceMotion ? 0 : 220)]).then(function (results) {
          if (thisLoad !== loadId) return;
          var html = results[0];
          row.innerHTML = html;
          resetShelfPosition();
          hydrateEntryPrices(row);
          window.requestAnimationFrame(function () {
            resetShelfPosition();
            row.classList.remove('is-refreshing');
            document.dispatchEvent(new CustomEvent('xtrait:wishlist:sync'));
          });
        });
      }

      hydrateEntryPrices(row);
      ensureCurrentShelf().then(function () {
        hydrateEntryPrices(row);
        resetShelfPosition();
      });
      resetShelfPosition();
      initHoverEdgeScroll();
      initEdgeArrows();
      window.addEventListener('load', function () {
        resetShelfPosition();
      }, { once: true });

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          setMode(button.getAttribute('data-x-featured-mode'));
        });
      });

      function blockSwipeClick() {
        blockClickUntil = Date.now() + 650;
      }

      row.addEventListener('touchstart', function (event) {
        var touch = event.touches && event.touches[0];
        if (!touch) return;
        touchStart = { x: touch.clientX, y: touch.clientY, scrollLeft: row.scrollLeft };
      }, { passive: true });

      row.addEventListener('touchmove', function (event) {
        if (!touchStart) return;
        var touch = event.touches && event.touches[0];
        if (!touch) return;
        var dx = Math.abs(touch.clientX - touchStart.x);
        var dy = Math.abs(touch.clientY - touchStart.y);
        var railMoved = Math.abs(row.scrollLeft - touchStart.scrollLeft) > 3;
        if (dx > 8 || dy > 8 || railMoved) {
          blockSwipeClick();
        }
      }, { passive: true });

      row.addEventListener('touchend', function () {
        if (touchStart && Math.abs(row.scrollLeft - touchStart.scrollLeft) > 3) {
          blockSwipeClick();
        }
        touchStart = null;
      }, { passive: true });

      row.addEventListener('touchcancel', function () {
        touchStart = null;
        blockSwipeClick();
      }, { passive: true });

      row.addEventListener('click', function (event) {
        if (Date.now() > blockClickUntil) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      }, true);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
